export default [
    {
        component: () => import(/* webpackChunkName: 'ambulatorio-jornada' */ '@/views/ambulatorio/jornada/Index'),
        path: 'jornada',
        redirect: 'jornada/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-jornada' */'@/views/ambulatorio/jornada/List.vue'),
                name: 'ambulatorio-jornada-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-jornada' */ '@/views/ambulatorio/jornada/Form.vue'),
                name: 'ambulatorio-jornada-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]